import { DetailSupportFormTestContainer } from "../../../containers/SupportSystem/SupportForm/DetailSupportFormTestContainer";
export function DetailSupportFormTestPage() {
    return (
        <DetailSupportFormTestContainer />
    );

}